/** @format **/
import React, { FunctionComponent } from 'react';
import { TableCell, TableRow } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import adescomStyle from '../../assets/jss/adescom/adescomStyle';
import EditButton from '../../components/Buttons/EditButton';
import I18n from '../../components/Translate/I18n';
import { SimCardServiceTemplate } from './SimCardServiceTemplate';
import { roles, UserRoleHelper } from '../../helpers/UserRoleHelper';
import DeleteButton from '../../components/Buttons/DeleteButton';
import OPL_STYLE from '../../assets/themes/OPL/OplStyle';

type ServiceTemplateItemType = {
    classes: any;
    item: SimCardServiceTemplate;
    setActiveRow: (id: number) => void;
    activeRow: number;
    viewCallback: (iri: { uri: string }, event: any) => void;
    deleteCallback: (iri: { uri: string }, event: any) => void;
};

export const ServiceTemplateItem: FunctionComponent<ServiceTemplateItemType> = ({
    classes,
    item,
    activeRow,
    setActiveRow,
    viewCallback,
    deleteCallback,
}): React.ReactElement => {
    const tableControlStickyHeader = { root: classes.tableControlStickyHeader };
    const tableCellRoot = { root: classes.tableCellRoot };
    const tableRowRoot = { root: classes.tableRowRoot };

    let rowActiveColor = 'white';
    if (activeRow === item.id) {
        rowActiveColor = OPL_STYLE.TABLE.ACTIVE_ROW;
    }

    return (
        <TableRow
            classes={tableRowRoot}
            key={'key' + item.id}
            hover
            onClick={(): void => {
                setActiveRow(item.id);
            }}
            style={{ backgroundColor: rowActiveColor }}
        >
            <TableCell classes={tableControlStickyHeader} padding="none" align="left" style={{ backgroundColor: rowActiveColor }}>
                {UserRoleHelper.checkRole(roles.ROLE_SIM_CARD_SERVICE_TEMPLATE_UPDATE) && (
                    <EditButton
                        callback={viewCallback}
                        callbackParam={{ uri: item['@id'] }}
                        tooltipTitle="prov:features.edit_template"
                        tooltipPlacement="bottom-start"
                    />
                )}
                {UserRoleHelper.checkRole(roles.ROLE_SIM_CARD_SERVICE_TEMPLATE_DELETE) && (
                    <DeleteButton
                        callback={deleteCallback}
                        callbackParam={{ uri: item['@id'] }}
                        tooltipTitle="prov:features.delete_template"
                        tooltipPlacement="bottom-start"
                    />
                )}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="left">
                {item.id}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="left">
                {item.templateName}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="left">
                {item.active && <I18n trans="general:common.yes" />}
                {!item.active && <I18n trans="general:common.no" />}
            </TableCell>
        </TableRow>
    );
};
